import React from 'react';
import SearchIcon from './search-icon.svg';
import './search.scss';
import { Input } from 'antd';
import {localize} from "mixins/helpers";

const SearchServices = (props: any) => {
    const icon = (
        <span className="anticon anticon-user site-form-item-icon">
            <SearchIcon />
        </span>
    );

    const onSearch = (value: any) => {
       props.onSearch(value.target.value);
    };

    return (
        <div className="search-services-block">
            <h1 className="search-services-block__label">
                {props.title}
            </h1>
            <div className="search-services-block__input-wrapper">
                <Input
                    placeholder={localize('what-going-to-look-for', props.translations)}
                    defaultValue={props.search}
                    onChange={onSearch}
                    prefix={icon}
                />
            </div>
        </div>
    );
};

export default SearchServices;
